import { validateAutomationPlanImport } from '../../utils/automation/automationPlanImportSchema';
import { buildPlanForSave } from './planBuilder';
import { mergeExecutionRecordIntoInstructions, extractDynamicResultFromPlan } from './executionRecordLoader';

/** Used by import round-trip tests and fixtures — not by the Export button (server export). */
export function buildExportPayload(instructions = [], dynamicResult = null, testCaseKey = null) {
    const plan = buildPlanForSave(instructions, dynamicResult, testCaseKey);
    const exportData = {
        instructions: instructions
            .filter((inst) => inst.text?.trim())
            .map((inst) => ({ id: inst.id, text: inst.text })),
        plan,
    };

    const validation = validateAutomationPlanImport(exportData);
    if (!validation.success) {
        return { ok: false, error: validation.error };
    }
    return { ok: true, data: exportData };
}

export function downloadJsonExport(exportData, filenamePrefix = 'automation-plan') {
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    const timeStr = `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
    a.download = `${filenamePrefix}-${dateStr}_${timeStr}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function parseImportFileContent(parsed) {
    const validation = validateAutomationPlanImport(parsed);
    if (!validation.success) {
        return { ok: false, error: validation.error };
    }

    const data = validation.data;
    const hasInstructionsField = Array.isArray(data.instructions) && data.instructions.length > 0;
    const hasPlanField =
        data.plan && typeof data.plan === 'object' && !Array.isArray(data.plan);

    let instructions;
    if (hasInstructionsField) {
        instructions = data.instructions
            .map((item, index) => ({
                id:
                    typeof item?.id === 'number' || typeof item?.id === 'string'
                        ? item.id
                        : Date.now() + index,
                text: typeof item?.text === 'string' ? item.text : '',
                aiSteps: [],
            }))
            .filter((inst) => inst.text.trim());

        if (instructions.length === 0) {
            instructions = [{ id: Date.now(), text: '', aiSteps: [] }];
        }
    } else {
        instructions = [{ id: Date.now(), text: '', aiSteps: [] }];
    }

    if (hasPlanField) {
        instructions = mergeExecutionRecordIntoInstructions(instructions, data.plan);
    }

    return {
        ok: true,
        instructions,
        dynamicResult: hasPlanField ? extractDynamicResultFromPlan(data.plan) : null,
        summary: {
            hasInstructionsField,
            hasPlanField,
            instructionCount: hasInstructionsField ? data.instructions.length : 0,
        },
    };
}
